"use strict";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TokenFetcher = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _logger = require("../logger");
var _TokenFetcher;
var hashFromKeys = [
    'method',
    'headers',
    'url'
];
var logger = _logger.mainLogger.createChild('TokenFetcher');
/**
 * Token fetching implementation. Handles multiple active requests
 */ var TokenFetcher = /*#__PURE__*/ function() {
    function TokenFetcher() {
        _class_call_check(this, TokenFetcher);
    }
    _create_class(TokenFetcher, null, [
        {
            key: "getStorage",
            value: /**
   * Gets current request storage
   */ function getStorage() {
                var _storageSpace_ori;
                // Check build out
                var storageSpace = globalThis;
                if (!((_storageSpace_ori = storageSpace.ori) === null || _storageSpace_ori === void 0 ? void 0 : _storageSpace_ori._tokenRequestsStorage)) {
                    if (!storageSpace.ori) {
                        storageSpace.ori = {};
                    }
                    storageSpace.ori._tokenRequestsStorage = new Map();
                }
                return storageSpace.ori._tokenRequestsStorage;
            }
        },
        {
            key: "createStorageKey",
            value: // NOTICE - making changes to output of this function may result in breaking change!
            /**
   * Hashes request options into storage key
   */ function createStorageKey(options) {
                var objectToHash = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = hashFromKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        if (key in options) {
                            objectToHash[key] = options[key];
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return JSON.stringify(objectToHash).toLowerCase();
            }
        },
        {
            key: "isStorageItemMissing",
            value: function isStorageItemMissing(key) {
                var storage = this.getStorage();
                var itemResolved = storage.get(key);
                return itemResolved === undefined;
            }
        },
        {
            key: "isStorageItemExpired",
            value: /**
   * Checks if existing is valid, if not found then returns true
   */ function isStorageItemExpired(key) {
                var _this = this;
                return _async_to_generator(function() {
                    var storage, itemResolved;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                storage = _this.getStorage();
                                return [
                                    4,
                                    storage.get(key)
                                ];
                            case 1:
                                itemResolved = _state.sent();
                                // This could happen if request is not successful
                                if (itemResolved === null) {
                                    return [
                                        2,
                                        false
                                    ];
                                }
                                // item is missing in storage
                                if (!itemResolved) {
                                    return [
                                        2,
                                        true
                                    ];
                                }
                                return [
                                    2,
                                    Date.parse(itemResolved.ExpirationDate) <= Date.now()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "upsertStorageItem",
            value: /**
   * Gets existing item or creates a new from factory
   */ function upsertStorageItem(key, factory) {
                var _this = this;
                return _async_to_generator(function() {
                    var storage, _tmp;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                storage = _this.getStorage();
                                _tmp = _this.isStorageItemMissing(key);
                                if (_tmp) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.isStorageItemExpired(key)
                                ];
                            case 1:
                                _tmp = _state.sent();
                                _state.label = 2;
                            case 2:
                                // We have to check for missing as fast possible(not async),
                                // Having await before initial set to storage will result in multiple promises created
                                if (_tmp) {
                                    storage.set(key, factory());
                                }
                                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- it's definitelly there since we checked :)
                                return [
                                    2,
                                    storage.get(key)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "removeStorageItem",
            value: /**
   * Deletes item from storage by key. Returns true if it was found and deleted, false othervise
   */ function removeStorageItem(key) {
                var storage = this.getStorage();
                return storage.delete(key);
            }
        },
        {
            key: "clearStorage",
            value: /**
   * clears storage from all promises
   */ function clearStorage() {
                var _globalThis_ori;
                if ((_globalThis_ori = globalThis.ori) === null || _globalThis_ori === void 0 ? void 0 : _globalThis_ori._tokenRequestsStorage) {
                    globalThis.ori._tokenRequestsStorage = undefined;
                }
            }
        }
    ]);
    return TokenFetcher;
}();
exports.TokenFetcher = TokenFetcher;
_TokenFetcher = TokenFetcher;
(0, _defineProperty2.default)(TokenFetcher, "DEFAULT_REQUEST_OPTIONS", {
    credentials: 'same-origin',
    headers: {
        // eslint-disable-next-line @typescript-eslint/naming-convention -- HTTP header name
        'X-Fetch-Api': '1',
        // eslint-disable-next-line @typescript-eslint/naming-convention -- HTTP header name
        'X-Requested-With': 'XMLHttpRequest'
    },
    method: 'GET'
});
(0, _defineProperty2.default)(TokenFetcher, "fetch", /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(options) {
        var url, requestOptions, key;
        return _ts_generator(this, function(_state) {
            url = options.url, requestOptions = _object_without_properties(options, [
                "url"
            ]);
            key = _TokenFetcher.createStorageKey(options);
            return [
                2,
                _TokenFetcher.upsertStorageItem(key, /*#__PURE__*/ _async_to_generator(function() {
                    var response, result, expirationDate;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetch(url, requestOptions)
                                ];
                            case 1:
                                response = _state.sent();
                                if (response.status >= 500) {
                                    _TokenFetcher.removeStorageItem(key);
                                    throw new Error("Token request ".concat(url, " failed on server or network error with status ").concat(response.statusText, "(").concat(response.status, ")"));
                                }
                                if (!response.ok) {
                                    logger.warn("Token request ".concat(url, " failed with status ").concat(response.statusText, "(").concat(response.status, ")"));
                                    return [
                                        2,
                                        null
                                    ];
                                }
                                return [
                                    4,
                                    response.json()
                                ];
                            case 2:
                                result = _state.sent();
                                if (result.ExpirationSeconds != null) {
                                    expirationDate = new Date();
                                    expirationDate.setSeconds(expirationDate.getSeconds() + result.ExpirationSeconds);
                                    return [
                                        2,
                                        _object_spread_props(_object_spread({}, result), {
                                            ExpirationDate: expirationDate.toISOString()
                                        })
                                    ];
                                }
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                }))
            ];
        });
    });
    return function(options) {
        return _ref.apply(this, arguments);
    };
}()); //# sourceMappingURL=TokenFetcher.js.map
